/**
 * `/app/mockups` — the route. The page is `pages/mockups/ClientMockupsPage.tsx` (session 48).
 */

import { createFileRoute } from '@tanstack/react-router'

import { ClientMockupsPage } from '../../../pages/mockups/ClientMockupsPage.js'

export const Route = createFileRoute('/app/mockups/')({
  component: ClientMockupsPage,
})
